module.exports = __webpack_public_path__ + "img/ORDER-HW.3dcb8899.png";